import { render, staticRenderFns } from "./XgPhone.vue?vue&type=template&id=7ba41100&scoped=true&"
import script from "./XgPhone.vue?vue&type=script&lang=js&"
export * from "./XgPhone.vue?vue&type=script&lang=js&"
import style0 from "./XgPhone.vue?vue&type=style&index=0&id=7ba41100&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba41100",
  null
  
)

export default component.exports